import type { ReactElement } from 'react';
import ConsentSiteSelector from '../../shared/agent-consent/SiteSelector/SiteSelector';
import { a2aSiteSelectorMessages } from './messages';
import { A2A_DOC_URL } from '../a2aUrls';

const A2A_SITE_SELECT_INPUT_ID = 'oauth-consent-a2a-site-select';

const SiteSelector: React.FC = (): ReactElement => (
  <ConsentSiteSelector
    messages={a2aSiteSelectorMessages}
    noWorkspacesLearnMoreUrl={A2A_DOC_URL}
    inputId={A2A_SITE_SELECT_INPUT_ID}
  />
);

export default SiteSelector;
